import { useQuery } from "react-query";
import { AemApi } from "@jti/rest-api";
export const useAem = (url) => {
    const aemApi = new AemApi(url);
    const { data, isLoading, isError } = useQuery("aemContentFragment", () => aemApi.getData());
    return {
        aemData: data,
        aemDataIsLoading: isLoading,
        aemDataIsError: isError,
    };
};
